import React, { useEffect } from "react";
import { Col, DatePicker, Input, Row, Select, Switch } from "antd";
import { useTranslation } from "react-i18next";
import { dbDateHour, langDateHour } from "../../../../utils/properties";
import { cloneDeep, filter, get, isEmpty, toLower } from "lodash";
import { useSelector } from "react-redux";
import { useState } from "react";
import FlatRateLocation from "../../../../services/api/FlatRateLocation";
import dayjs from "dayjs";

const { Option } = Select;

function FlatRate({ form, detailFolder, modal, modalViewData, canEdit }) {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const dateHourFormat = langDateHour[toLower(currentLanguage)];
  const [state, setState] = useState({
    expenseAccountTypeList: [],
    fuelCardsList: [],
    suppliersList: [],
    locationDepartureList: [],
    locationArrivalList: [],
    parkAutosList: [],
  });

  useEffect(() => {
    if (modal?.type === "edit" || modal?.type === "visualizer") {
      flatRateLocation();
    }
  }, [modal?.type]);

  const flatRateLocation = async () => {
    if (isEmpty(state.locationDepartureList) || isEmpty(state.locationArrivalList)) {
      let locationDepartureList = [];
      let locationArrivalList = [];
      const { error, data } = await FlatRateLocation.getFlatRateLocations(`allPages=true`);
      if (!error && data) {
        locationDepartureList = filter(data, (d) => d.type === "DEPARTURE");
        locationArrivalList = filter(data, (d) => d.type === "ARRIVAL");
      }
      setState((prevState) => ({
        ...prevState,
        locationDepartureList,
        locationArrivalList,
      }));
    }
  };

  return (
    <>
      {modalViewData ? (
        <>
          <Row gutter={[40, 24]} className="mb-10" justify="space-around">
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="flight">
                  {t("expenseRefundFolder.table.flight")}
                </label>
              </Row>
              <Row>
                <Switch
                  id="flight"
                  name="flight"
                  disabled={true}
                  checked={modalViewData.flight}
                  checkedChildren={t("general.yes")}
                  unCheckedChildren={t("general.no")}
                />
              </Row>
            </Col>
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="abroad">
                  {t("expenseRefundFolder.table.abroad")}
                </label>
              </Row>
              <Row>
                <Switch
                  id="abroad"
                  name="abroad"
                  disabled={true}
                  checked={modalViewData.abroad}
                  checkedChildren={t("general.yes")}
                  unCheckedChildren={t("general.no")}
                />
              </Row>
            </Col>
          </Row>
          <Row gutter={[40, 24]} className="mb-10" justify="space-around">
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="departureDate">
                  {t("expenseRefundFolder.table.departureDate")}
                </label>
              </Row>
              <Row>
                <Input
                  className="w-100"
                  id="departureDate"
                  name="departureDate"
                  format={dateHourFormat}
                  locale={langDateHour[`locale_${toLower(currentLanguage)}`]}
                  disabled={true}
                  value={dayjs(modalViewData.departureDate, dbDateHour).format(dateHourFormat)}
                />
              </Row>
            </Col>
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="arrivalDate">
                  {t("expenseRefundFolder.table.arrivalDate")}
                </label>
              </Row>
              <Row>
                <Input
                  className="w-100"
                  id="arrivalDate"
                  name="arrivalDate"
                  format={dateHourFormat}
                  locale={langDateHour[`locale_${toLower(currentLanguage)}`]}
                  disabled={true}
                  value={dayjs(modalViewData.arrivalDate, dbDateHour).format(dateHourFormat)}
                />
              </Row>
            </Col>
          </Row>
          <Row
            gutter={[40, 24]}
            className="mb-10"
            justify="space-around"
            style={{ display: modalViewData.flight ? "flex" : "none" }}
          >
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="locationDeparture">
                  {t("expenseRefundFolder.table.locationDeparture")}
                </label>
              </Row>
              <Input
                className="w-100"
                id="locationDeparture"
                name="locationDeparture"
                placeholder={t("expenseRefundFolder.table.locationDeparture")}
                disabled={true}
                value={modalViewData.locationDeparture?.location}
              />
            </Col>
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="locationArrival">
                  {t("expenseRefundFolder.table.locationArrival")}
                </label>
              </Row>
              <Input
                className="w-100"
                id="locationArrival"
                name="locationArrival"
                placeholder={t("expenseRefundFolder.table.locationArrival")}
                disabled={true}
                value={modalViewData.locationArrival?.location}
              />
            </Col>
          </Row>
          <Row
            gutter={[40, 24]}
            className="mb-10"
            justify="space-around"
            style={{ display: !modalViewData.flight ? "flex" : "none" }}
          >
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="locationDepartureDesc">
                  {t("expenseRefundFolder.table.locationDepartureDesc")}
                </label>
              </Row>
              <Row>
                <Input
                  id="locationDepartureDesc"
                  name="locationDepartureDesc"
                  disabled={true}
                  value={modalViewData.locationDepartureDesc}
                />
              </Row>
            </Col>
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="locationArrivalDesc">
                  {t("expenseRefundFolder.table.locationArrivalDesc")}
                </label>
              </Row>
              <Row>
                <Input
                  id="locationArrivalDesc"
                  name="locationArrivalDesc"
                  disabled={true}
                  value={modalViewData.locationArrivalDesc}
                />
              </Row>
            </Col>
          </Row>
          <Row gutter={[40, 24]} className="mb-10" justify="space-around">
            <Col lg={22} md={22} xs={24} sm={22}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="note">
                  {t("expenseRefundFolder.table.note")}
                </label>
              </Row>
              <Row>
                <Input id="note" name="note" disabled={true} value={modalViewData.note} />
              </Row>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row gutter={[40, 24]} className="mb-10" justify="space-around">
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="flight">
                  {t("expenseRefundFolder.table.flight")}
                </label>
              </Row>
              <Row>
                <Switch
                  id="flight"
                  name="flight"
                  onChange={(e) => {
                    form?.setFieldValue("locationDeparture", null);
                    form?.setFieldValue("locationArrival", null);
                    form?.setFieldValue("locationDepartureDesc", null);
                    form?.setFieldValue("locationArrivalDesc", null);
                    form?.setFieldValue("flight", e);
                    if (e === true) {
                      flatRateLocation();
                    }
                  }}
                  onBlur={form?.handleBlur}
                  checked={form?.values.flight}
                  checkedChildren={t("general.yes")}
                  unCheckedChildren={t("general.no")}
                  disabled={!canEdit}
                />
              </Row>
            </Col>
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="abroad">
                  {t("expenseRefundFolder.table.abroad")}
                </label>
              </Row>
              <Row>
                <Switch
                  id="abroad"
                  name="abroad"
                  onChange={(e) => form?.setFieldValue("abroad", e)}
                  onBlur={form?.handleBlur}
                  checked={form?.values.abroad}
                  checkedChildren={t("general.yes")}
                  unCheckedChildren={t("general.no")}
                  disabled={!canEdit}
                />
              </Row>
            </Col>
          </Row>
          <Row gutter={[40, 24]} className="mb-10" justify="space-around">
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="departureDate">
                  {t("expenseRefundFolder.table.departureDate")}*
                </label>
              </Row>
              <Row>
                <DatePicker
                  disabled={!canEdit}
                  showTime={{ defaultValue: dayjs("00:00", "HH:mm") }}
                  className="w-100"
                  allowClear={false}
                  id="departureDate"
                  name="departureDate"
                  format={dateHourFormat}
                  locale={langDateHour[`locale_${toLower(currentLanguage)}`]}
                  onChange={(date) => {
                    form?.setFieldValue("departureDate", date);
                  }}
                  onBlur={form?.handleBlur}
                  value={form?.values.departureDate}
                  disabledDate={(current) => {
                    // Set the minimum and maximum allowed dates
                    const minDate = dayjs(detailFolder?.periodStart);
                    const maxDate = dayjs(detailFolder?.periodEnd).add(1, "days");
                    // Disable all dates before minDate and after maxDate, except maxDate itself
                    return current && (current < minDate || current > maxDate);
                  }}
                />
              </Row>
            </Col>
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="arrivalDate">
                  {t("expenseRefundFolder.table.arrivalDate")}*
                </label>
              </Row>
              <Row>
                <DatePicker
                  disabled={!canEdit || form?.values.departureDate === null}
                  showTime={{ defaultValue: dayjs("00:00", "HH:mm") }}
                  className="w-100"
                  allowClear={false}
                  id="arrivalDate"
                  name="arrivalDate"
                  format={dateHourFormat}
                  locale={langDateHour[`locale_${toLower(currentLanguage)}`]}
                  onChange={(date) => {
                    form?.setFieldValue("arrivalDate", date);
                  }}
                  onBlur={form?.handleBlur}
                  value={form?.values.arrivalDate}
                  disabledDate={(current) => {
                    // Set the minimum and maximum allowed dates
                    const minDate = cloneDeep(form?.values.departureDate);
                    const maxDate = dayjs(detailFolder?.periodEnd).add(1, "days");
                    // Disable all dates before minDate and after maxDate, except maxDate itself
                    return current && (current < minDate || current > maxDate);
                  }}
                />
              </Row>
            </Col>
          </Row>
          <Row
            gutter={[40, 24]}
            className="mb-10"
            justify="space-around"
            style={{ display: form?.values.flight ? "flex" : "none" }}
          >
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="locationDeparture">
                  {t("expenseRefundFolder.table.locationDeparture")}*
                </label>
              </Row>
              <Select
                disabled={!canEdit}
                className="w-100"
                id="locationDeparture"
                name="locationDeparture"
                placeholder={t("expenseRefundFolder.table.locationDeparture")}
                onChange={(value) => {
                  form?.setFieldValue("locationDeparture", value);
                }}
                onBlur={() => {
                  form?.handleBlur("locationDeparture");
                }}
                value={form?.values.locationDeparture}
              >
                {state.locationDepartureList.map((locationDeparture) => {
                  return (
                    <Option key={locationDeparture.id} value={locationDeparture.id} name={locationDeparture.location}>
                      {locationDeparture.location}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="locationArrival">
                  {t("expenseRefundFolder.table.locationArrival")}*
                </label>
              </Row>
              <Select
                disabled={!canEdit}
                className="w-100"
                id="locationArrival"
                name="locationArrival"
                placeholder={t("expenseRefundFolder.table.locationArrival")}
                onChange={(value) => {
                  form?.setFieldValue("locationArrival", value);
                }}
                onBlur={() => {
                  form?.handleBlur("locationArrival");
                }}
                value={form?.values.locationArrival}
              >
                {state.locationArrivalList.map((locationArrival) => {
                  return (
                    <Option key={locationArrival.id} value={locationArrival.id} name={locationArrival.location}>
                      {locationArrival.location}
                    </Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          <Row
            gutter={[40, 24]}
            className="mb-10"
            justify="space-around"
            style={{ display: !form?.values.flight ? "flex" : "none" }}
          >
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="locationDepartureDesc">
                  {t("expenseRefundFolder.table.locationDepartureDesc")}*
                </label>
              </Row>
              <Row>
                <Input
                  disabled={!canEdit}
                  required
                  id="locationDepartureDesc"
                  name="locationDepartureDesc"
                  onChange={form?.handleChange}
                  onBlur={form?.handleBlur}
                  value={form?.values.locationDepartureDesc}
                />
              </Row>
            </Col>
            <Col lg={10} md={10} xs={24} sm={10}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="locationArrivalDesc">
                  {t("expenseRefundFolder.table.locationArrivalDesc")}*
                </label>
              </Row>
              <Row>
                <Input
                  disabled={!canEdit}
                  required
                  id="locationArrivalDesc"
                  name="locationArrivalDesc"
                  onChange={form?.handleChange}
                  onBlur={form?.handleBlur}
                  value={form?.values.locationArrivalDesc}
                />
              </Row>
            </Col>
          </Row>
          <Row gutter={[40, 24]} className="mb-10" justify="space-around">
            <Col lg={22} md={22} xs={24} sm={22}>
              <Row>
                <label className="fw-bold mt-10" htmlFor="note">
                  {t("expenseRefundFolder.table.note")}*
                </label>
              </Row>
              <Row>
                <Input
                  disabled={!canEdit}
                  required
                  id="note"
                  name="note"
                  onChange={form?.handleChange}
                  onBlur={form?.handleBlur}
                  value={form?.values.note}
                />
              </Row>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default FlatRate;
